module.exports = __webpack_public_path__ + "img/regComm-2.c69f9862.jpg";